import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { HELP_DESK_PRIORITY_LABEL_KEYS } from '@ubeya/shared/constants/helpDesk';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import Tooltip from '@ubeya/shared-web/components/Tooltip/Tooltip';
import { PRIORITY_ICON_MAP } from '../../helpDeskConstants';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  ${({ $disabled, theme }) =>
    $disabled &&
    css`
      color: ${theme.colors.grey4};
      cursor: default;
    `}
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  svg {
    width: 20px;
    height: 20px;
  }
`;

const PriorityLabel = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  line-height: 20px;
  font-size: 12px;
`;

const PriorityDisplay = ({ priority, compact = false, disabled = false }) => {
  const { t } = useContext(ConfigContext);
  const PriorityIconComponent = PRIORITY_ICON_MAP[priority] || PRIORITY_ICON_MAP.NONE;

  if (!PriorityIconComponent) return null;

  const label = HELP_DESK_PRIORITY_LABEL_KEYS[priority] ? t(HELP_DESK_PRIORITY_LABEL_KEYS[priority]) : '';

  return (
    <Tooltip body={label}>
      <Wrapper $disabled={disabled} title={label}>
        <IconWrap>
          <PriorityIconComponent />
        </IconWrap>
        {!compact && <PriorityLabel>{label}</PriorityLabel>}
      </Wrapper>
    </Tooltip>
  );
};

export default PriorityDisplay;
